<template>
  <div
    class="container new__container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu @searchClick="searchClick"></dingbu>
    <div class="home_content">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">联系我们</span>
            </div>
          </div>
          <div class="box_contentm">
            <div class="w">
              <div class="box_lonm">
                <div class="bo__img">
                  <img :src="calImage" alt="" />
                </div>
                <div class="lian_me">
                  <div class="lian_title">
                    <div class="list_name">联系我们</div>
                  </div>
                  <div class="text_nex">
                    <div class="lian_content" v-html="listtodo"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dibu></dibu>
    <daohan></daohan>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      addki: [],
      bei_ing: this.Public.bei_ing,
      listtodo: '是财牛（上海）教育科技有限公司打造的自学教育平台。自2016年成立以来，秉承着敬业与坚持的企业精神，已成功搭建了一个提供优质、高清教学视频的网络自学平台，用户可以根据行业和兴趣爱好，自主选择学习内容，每天进步一点点 立足于广大用户自学的需',
      callmy: '',
      calImage: '',
      is_change: false,
    };
  },
  mounted() {
  },
  created() {
    this.getcallme()
  },
  methods: {
    searchClick(val) {
      // console.log(val, 'val')
      this.addki = val.info
    },
    //点击跳转到课程详情页
    todolist() {
      this.$router.push({ path: "/details" });
    },
    //系统中心接口
    getcentert() {
      let that = this;
      var url = "index/center";
      let param = {};
      this.post(url)
        .then((res) => {
          this.addki = res.data;
          // console.log(res);
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    async getcallme() {  //联系我们
      let that = this, url = "index/about", param = {};
      try {
        const { data } = await this.post(url)
        // console.log(data, "联系我们");
        this.callmy = data
        this.calImage = data.image
        this.listtodo = data.content
      } catch (err) {
        // console.log(err);
      }
    },
  },
}
</script>
<style scoped lang="less">
.container {
  width: 100%;
  height: 100%;
  margin-top: 213px;

  .home_content {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 106px;

    .bg_color {
      width: 100%;
      height: 100%;
      padding-top: 16px;
      box-sizing: border-box;

      .inform__box {
        width: 100%;

        .box__top {
          width: 100%;
          padding: 15px 0 24px 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          .shou__ye {
            font-size: 14px;
            color: #06121e;
          }

          .img__o {
            width: 7px;
            height: 12px;
            margin-left: 11px;
          }

          .ton__zhi {
            font-size: 14px;
            color: #8c9198;
            margin-left: 12px;
          }
        }
      }

      .box_contentm {
        width: 100%;

        .box_lonm {
          width: 100%;
          padding: 33px 38px;
          box-sizing: border-box;
          background-color: #fff;
          display: flex;

          .bo__img {
            width: 413px;
            height: 275px;
            margin-right: 38px;

            img {
              width: 100%;
              height: 275px;
            }
          }
          .lian_me {
            flex: 1;

            .lian_title {
              width: 100%;

              .list_name {
                width: 70%;
                height: 34px;
                border-bottom: 1px solid #eaeaea;
                box-sizing: border-box;
                font-size: 22px;
                font-family: Source Han Sans CN, Source Han Sans CN-Bold;
                font-weight: 700;
                text-align: left;
                color: #06121e;
                line-height: 24px;
                position: relative;

                &::after {
                  content: "";
                  position: absolute;
                  bottom: -2px;
                  left: 0;
                  width: 152px;
                  height: 4px;
                  background: #d6a07a;
                }
              }
            }
            .text_nex {
              margin-top: 45px;
              width: 100%;

              .lian_content {
                width: 100%;
                padding-right: 20px;
                box-sizing: border-box;
                font-size: 14px;
                color: #06121e;
              }
            }
          }
        }
      }
    }
  }
}
</style>